import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Shield, Car, Lock, Phone, ArrowLeft } from 'lucide-react';
import './AdminLogin.css';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function Login({ initialRole = 'admin' }) {
    const [role, setRole] = useState(initialRole);
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            if (role === 'admin') {
                const response = await axios.post(`${API_URL}/api/admin/login`, { password });
                localStorage.setItem('token', response.data.token);
                navigate('/admin/dashboard');
            } else {
                const response = await axios.post(`${API_URL}/api/driver/login`, { phone, password });
                localStorage.setItem('driverToken', response.data.token);
                localStorage.setItem('driverName', response.data.driver.name);
                navigate('/driver/dashboard');
            }
        } catch (error) {
            setError('Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h1>
                    {role === 'admin' ? <Shield size={28} className="login-icon" /> : <Car size={28} className="login-icon" />}
                    {role === 'admin' ? 'Admin Login' : 'Driver Login'}
                </h1>

                <div className="role-toggle">
                    <button
                        type="button"
                        className={role === 'admin' ? 'active' : ''}
                        onClick={() => { setRole('admin'); setError(''); }}
                    >
                        Admin
                    </button>
                    <button
                        type="button"
                        className={role === 'driver' ? 'active' : ''}
                        onClick={() => { setRole('driver'); setError(''); }}
                    >
                        Driver
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    {role === 'driver' && (
                        <div className="form-group">
                            <label htmlFor="phone">
                                <Phone size={16} style={{ display: 'inline', marginRight: '4px', verticalAlign: '-2px' }} />
                                Phone Number
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                                placeholder="Enter your phone number"
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="password">
                            <Lock size={16} style={{ display: 'inline', marginRight: '4px', verticalAlign: '-2px' }} />
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Enter password"
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                <div className="back-link">
                    <a href="/">
                        <ArrowLeft size={16} /> Back to Booking
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Login;